import * as React from 'react';
import { connect } from 'react-redux';
import { AppConstants } from '../../constants/AppConstants';
import { Utils, domainVal, NumberFormatter, i18n, DateFormatter, domain } from 'arm-common';
import ApplicationData from '../../app/aApplicationData'
import * as agui from 'arm-gui/dist/controls';
class ContraentiTable extends React.Component {
    constructor(props) {
        super(props);
        // this.detailsOnClick = this.detailsOnClick.bind(this);
        this.componentName = '[ContraentiTable.jsx] ';
        // this.aggiungiGaranziaOnClick = this.aggiungiGaranziaOnClick.bind(this);
    }


    componentDidMount() {
        console.log(this.componentName + ' componentDidMount');

        let columns = [];
        if (this.props.source && this.props.source === "microCategoriaCreate") {
            columns = [
                { checkbox: true, field: "checked", visible: this.props.source && this.props.source === "microCategoriaCreate" },
                { field: 'codCampo', title: 'Id', sortable: 'true' },
                { field: 'valCampo', title: i18n('ARM_CORE_PRODUCT.SHARED.VALORE', 'Valore'), sortable: 'true' },
                { field: 'desDom', title: i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione'), sortable: 'true', },
                { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), sortable: 'true', },
            ]
        } else {
            columns = [
                { field: 'idMicroCategoriaContraente', title: 'Id', sortable: 'true' },
                { field: 'contraente', title: i18n('ARM_CORE_PRODUCT.SHARED.VALORE', 'Valore'), sortable: 'true', formatter: this.contraenteFormatter },
                { field: 'idUserUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato Da'), sortable: 'true', },
                { field: 'dateUpd', title: i18n('ARM_CORE_PRODUCT.SHARED.DATA_UPDATE', 'Data Ultima Modifica'), sortable: 'true', formatter: this.dateFormatter, },
            ]
        }

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "idMicroCategoriaContraente",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            clickToSelect: true,
            maintainMetaData: true,
            maintainSelected: true,
            // onClickRow: (row, $element, field) => this.props.source && this.props.source === "gpCreate" ? this.aggiungiGaranziaOnClick(row, $element, field) : null,
            sortOrder: "desc",
            pagination: true,


        });

        if (this.props.source && this.props.source === "microCategoriaCreate") {
            this.props.inizializzaModificaContraenti().then(

                resolve => {
                    if (this.props.contraenti !== null && this.props.contraenti !== undefined) {

                        $(this.refs.MyTable).bootstrapTable('load', this.props.contraenti);
                    }

                }
            )
        } else {

            if (this.props.contraenti !== null && this.props.contraenti !== undefined) {

                $(this.refs.MyTable).bootstrapTable('load', this.props.contraenti);
            }


        }


    }

    dateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(value);
    }

    contraenteFormatter(value, row, index) {
        return ApplicationData.domainVal("AI_TIPO_CONTRAENTE", row.contraente, row.contraente).desDom
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.contraenti !== this.props.contraenti) {
            console.log("\t rows: " + (nextProps.contraenti !== null ? nextProps.contraenti.length : "NULL"));

            if (nextProps.contraenti === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.contraenti);
            }
        }
    }

    render() {
        console.log(this.componentName + ' render');
        return (
            <div className="card-body">
                <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
            </div>
        );
    }
};



export default ContraentiTable;
